

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { diffWordsWithSpace } from 'diff';

interface DiffViewerProps {
  previous: string;
  current: string;
}

function cleanHtml(html: string): string {
  if (!html) return '';
  // Replace <p> closing tags with double newline to preserve paragraph structure
  // Replace <br> with single newline for hard breaks
  // Remove opening <p> tags even if they have attributes
  let text = html
    .replace(/<p[^>]*>/gi, '')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<br\s*\/?>/gi, '\n');
  const temp = document.createElement('div');
  temp.innerHTML = text;
  // Trim to avoid trailing double newlines, but preserve internal ones
  return (temp.textContent || temp.innerText || '').trim();
}

export function DiffViewer({ previous, current }: DiffViewerProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const diff = diffWordsWithSpace(cleanHtml(previous), cleanHtml(current));

  return (
    <Box
      sx={{
        fontFamily: 'font-body',
        lineHeight: 1.2,
        fontSize: '1.1rem',
        whiteSpace: 'pre-wrap',
        minHeight: '400px',
        maxHeight: '70vh',
        overflow: 'auto',
        p: 2,
        color: 'text.primary'
      }}
    >
      {diff.map((part, index) => (
        <span
          key={index}
          style={{
            backgroundColor: part.added
              ? (isDark ? 'rgba(46, 160, 67, 0.25)' : '#e6ffec')
              : part.removed
                ? (isDark ? 'rgba(248, 81, 126, 0.25)' : '#ffebe9')
                : 'transparent',
            color: part.added
              ? (isDark ? '#a5d6ff' : '#24292e')
              : part.removed
                ? (isDark ? '#ffa198' : '#b31d28')
                : 'inherit',
            textDecoration: part.removed ? 'line-through' : 'none',
            borderRadius: '2px',
            padding: '2px 0',
          }}
        >
          {part.value}
        </span>
      ))}
    </Box>
  );
}
